/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import StatsCard from "../../Cards/statsCard";
import { CARD_GAP, REFETCH_CONFIGURATION } from "../../../utils/constants";
import SiteLocationMap from "./Map";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { useAppSelector } from "../../../store/hooks";
import { useEffect, useState } from "react";
import PowerConsumptionBySite from "../../Charts/PowerConsumptionBySite";
import ExpectedRevenueBySite from "../../Charts/RevenueByDistrict";
import { formatCustomDateDayMonthYear } from "../../../utils/utils";
import { useUtils } from "../../../customHooks/useUtils";

function Manager({ company_id }: { company_id: string }) {
  
  const { t, FEEDBACK_MESSAGES, mapResponseToLabelValue, INSTATAENOUS_KPIS } = useUtils();
  const excludeCards = [t("readings.unknown")];
  const [isLocalLoading, setIsLocalLoading] = useState(false);
  const startDate = useAppSelector((state) => state.filter.startDate);
  const endDate = useAppSelector((state) => state.filter.endDate);

  const {
    data: managerData,
    isLoading: isDataLoading,
    error,
    refetch,
  } = useFetchData(
    ["/manager", "fetchManager", company_id],
    "/manager/cards-data",
    {
      card_type: "manager_home",
      company_id,
      start_date: startDate,
      end_date: endDate,
    },
    // @ts-ignore
    {
      ...REFETCH_CONFIGURATION,
    }
  );
  // console.log("CheckingData", (error as any).response);
  const isLoading =
    // Show loading for initial page load
    isDataLoading ||
    // Show loading when filter is applied and when actually refetching
    isLocalLoading;

  useEffect(() => {
    if (startDate && endDate) {
      setIsLocalLoading(true);

      refetch().finally(() => {
        setIsLocalLoading(false);
      });
    }
  }, [startDate, endDate, refetch]);
  const transformedData = managerData ? mapResponseToLabelValue(managerData) : [];
  return (
    <div
      className="flex flex-col items-start justify-center w-full"
      style={{ gap: CARD_GAP }}
    >
      {/* stats wrapper */}
      <div
        className="grid w-full [grid-template-columns:repeat(auto-fit,minmax(200px,1fr))]"
        style={{
          gap: CARD_GAP,
        }}
      >
        {isLoading
          ? Array.from({ length: 4 }).map((_, index) => (
              <StatsCard
                key={index}
                title=""
                value=""
                isError={false}
                isLoading={true}
              />
            ))
          : error
          ? (error as any).response.data.detail
            ? Array.from({ length: 4 }).map((_, index) => (
                <StatsCard
                  key={index}
                  title=""
                  value=""
                  errorType={FEEDBACK_MESSAGES.NO_DEVICE}
                  isError={true}
                  isLoading={false}
                  cardErrorStyle="!h-[50px]"
                />
              ))
            : Array.from({ length: 4 }).map((_, index) => (
                <StatsCard
                  key={index}
                  title=""
                  value=""
                  isError={true}
                  isLoading={false}
                  cardErrorStyle="!h-[50px]"
                />
              ))
          : transformedData.map(
              (data, index) =>
                !excludeCards.includes(data.label) && (
                  <div key={index}>
                    <StatsCard
                      title={data.label}
                      value={data.value as string}
                      isError={!!error && !isLoading && !data}
                      isLoading={isLoading}
                      time={
                        INSTATAENOUS_KPIS.includes(data.label)
                          ? (managerData as any).time
                          : ""
                      }
                      period={
                        !INSTATAENOUS_KPIS.includes(data.label)
                          ? formatCustomDateDayMonthYear(startDate, endDate)
                          : ""
                      }
                    />
                  </div>
                )
            )}
      </div>

      {/* chats wrapper */}
      <div
        className="flex flex-col xl:flex-row flex-wrap justify-between w-full"
        style={{ gap: CARD_GAP }}
      >
        <div
          className="flex flex-col flex-1 xl:max-w-[70%]"
          style={{ gap: CARD_GAP }}
        >
          <SiteLocationMap company_id={company_id} />
          {/* <div
            className="grid w-full !justify-start !items-start"
            style={{
              gap: CARD_GAP,
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            }}
          >
            {isLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                  <StatsCard
                    key={index}
                    title=""
                    value=""
                    isError={false}
                    isLoading={true}
                  />
                ))
              : transformedData.map(
                  (data, index) =>
                    !excludeCards.includes(data.label) && (
                 
                      <div key={index}>
                        <StatsCard
                          title={data.label}
                          value={data.value as string}
                          time={
                            INSTATAENOUS_KPIS.includes(data.label)
                              ? (data as any).time
                              : ""
                          }
                          period={
                            !INSTATAENOUS_KPIS.includes(data.label)
                              ? formatCustomDateDayMonthYear(startDate, endDate)
                              : ""
                          }
                          isError={!!error && !isLoading && !data}
                          isLoading={isLoading}
                          className=""
                        />
                      </div>
                    )
                )}
          </div> */}
        </div>
        <div
          className="w-full  flex flex-col lg:flex-row max-w-[100%] overflow-x-hidden"
          style={{ gap: CARD_GAP }}
        >
          <ExpectedRevenueBySite
            company_id={company_id}
            startDate={startDate}
            endDate={endDate}
          />
          <PowerConsumptionBySite
            company_id={company_id}
            startDate={startDate}
            endDate={endDate}
          />
        </div>
      </div>
    </div>
  );
}

export default Manager;
